import React from 'react';

import SchoolList from './components/SchoolList';
import { FCWithChildren } from '@types';

const Admin: FCWithChildren<{}> = () => <SchoolList />;

export default Admin;
